import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    makeStyles,
} from '@material-ui/core';

interface DialogProps {
    open: boolean;
    title: string;
    onClose: () => void;
    onSubmit: (e: React.SyntheticEvent) => void;
    icon?: React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
    submitDisabled?: boolean;
    children: React.ReactNode;
}

const CustomDialog = ({
    open,
    title,
    onClose,
    onSubmit,
    maxWidth = 'sm',
    icon = null,
    submitDisabled = false,
    children,
}: DialogProps) => {
    const classes = useStyles();

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            className={classes.root}
            maxWidth={maxWidth}
        >
            <div className={classes.dialog}>
                <div className={classes.gradient} />
                <form onSubmit={onSubmit} className={classes.content}>
                    <DialogTitle className={classes.header}>
                        {icon && <div className={classes.icon}>{icon}</div>}
                        <div className={classes.title}>{title}</div>
                    </DialogTitle>
                    <DialogContent>{children}</DialogContent>
                    <DialogActions className={classes.actions}>
                        <Button
                            onClick={onClose}
                            className={`${classes.button} ${classes.cancelButton}`}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            className={`${classes.button} ${classes.submitButton}`}
                            disabled={submitDisabled}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </div>
        </Dialog>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    dialog: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
    },
    gradient: {
        minWidth: '20px',
        background: 'linear-gradient(0deg, #D6E6FF 0%, #E4FEFF 100%)',
        minHeight: '100%',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: '27px',
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '27px',
        float: 'left',
        width: '49px',
        height: '49px',
    },
    title: {
        display: 'flex',
        color: theme.palette.primary.main,
        fontFamily: 'Poppins',
        fontSize: '32px',
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: '150%',
        letterSpacing: '-0.576px',
    },
    content: {
        padding: '20px',
    },
    actions: {
        padding: '20px',
    },
    button: {
        display: 'flex',
        height: '36px',
        padding: '4px 24px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '25px',
        color: theme.palette.primary.main,
        fontFamily: 'Noto Sans',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: '150%' /* 21px */,
        letterSpacing: '-0.14px',
        textTransform: 'none',
    },
    cancelButton: {
        backgroundColor: theme.palette.gray.light,
    },
    submitButton: {
        backgroundColor: theme.palette.primary.light,
    },
}));

export default CustomDialog;
